import { useState, useEffect } from "react";
import { getPromotionUsage } from "../../../api/catalog";
import type { PromotionUsage } from "../../../api/catalog";

type PromotionTabUsageProps = {
  promotionId: string;
};

export function PromotionTabUsage({ promotionId }: PromotionTabUsageProps) {
  const [usage, setUsage] = useState<PromotionUsage[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    getPromotionUsage(promotionId)
      .then((data) => {
        if (mounted) setUsage(data);
      })
      .catch(() => {
        if (mounted) setUsage([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [promotionId]);

  const totalDiscount = usage.reduce((s, u) => s + u.discount_amount, 0);
  const count = usage.length;

  if (loading) {
    return <p className="text-sm text-muted">Chargement...</p>;
  }

  return (
    <div className="space-y-6">
      <h3 className="text-sm font-semibold text-text">Utilisation / Audit</h3>

      <div className="grid gap-4 md:grid-cols-3">
        <div className="rounded-md border border-border bg-surface p-4">
          <div className="text-2xl font-semibold text-text">{count}</div>
          <div className="text-xs text-muted">Utilisations</div>
        </div>
        <div className="rounded-md border border-border bg-surface p-4">
          <div className="text-2xl font-semibold text-text">{totalDiscount.toFixed(2)} $</div>
          <div className="text-xs text-muted">Rabais total</div>
        </div>
        <div className="rounded-md border border-border bg-surface p-4">
          <div className="text-2xl font-semibold text-text">
            {count > 0 ? (totalDiscount / count).toFixed(2) : "0"} $
          </div>
          <div className="text-xs text-muted">Rabais moyen</div>
        </div>
      </div>

      <div>
        <h4 className="text-xs font-medium text-muted mb-2">Historique</h4>
        {usage.length === 0 ? (
          <p className="text-sm text-muted">Aucune utilisation enregistrée</p>
        ) : (
          <div className="overflow-x-auto rounded-md border border-border">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border bg-surface-muted/50">
                  <th className="text-left p-2 font-medium text-text">Date</th>
                  <th className="text-left p-2 font-medium text-text">Montant de base</th>
                  <th className="text-left p-2 font-medium text-text">Rabais</th>
                  <th className="text-left p-2 font-medium text-text">Prix final</th>
                </tr>
              </thead>
              <tbody>
                {usage.map((u) => (
                  <tr key={u.id} className="border-b border-border">
                    <td className="p-2 text-muted">
                      {new Date(u.used_at).toLocaleString("fr-FR")}
                    </td>
                    <td className="p-2">{Number(u.applied_to_amount).toFixed(2)} $</td>
                    <td className="p-2 text-primary">-{Number(u.discount_amount).toFixed(2)} $</td>
                    <td className="p-2">{Number(u.final_price).toFixed(2)} $</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
